<template>
  <div class="btn-group dropleft" role="group">
    <button
      type="button"
      class="btn dropdown-toggle-split p-0"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <span class="sr-only"></span>
      <img
        v-if="selectedTabName !== archived"
        style="width: 5px"
        src="https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg"
        alt=""
      />
    </button>

    <div class="dropdown-menu bg-white" aria-labelledby="dropdownMenuLink">
      <a
        class="dropdown-item font-16"
        v-if="showHideEdit"
        :href="`/Project/Edit/${card.id}`"
        ref="dynamicEditLink"
      >
        {{ $resourceString["myProject.Project.EditProject.Title"] }}
      </a>
      <a
        class="dropdown-item font-16"
        v-if="selectedTabName === archived || selectedTabName === active"
        href=""
        :class="{ disabled: isDisabled }"
        @click.prevent="handleArchiveTray"
      >
        {{
          selectedTabName === archived
            ? $resourceString["myProject.Project.ReactivateProject.Title"]
            : $resourceString["myProject.Project.ArchivedProject.Title"]
        }}</a
      >
      <a
        class="dropdown-item font-16"
        href=""
        v-if="
          selectedTabName === brand &&
            card.brandBoardStatus === 0 &&
            isAdminMode
        "
        @click.prevent="publishTray(card.id)"
      >
        {{ $resourceString["account.Trays.Option.Publish.Tray"] }}
      </a>
      <a
        class="dropdown-item font-16"
        href=""
        v-if="
          selectedTabName === brand &&
            card.brandBoardStatus === 2 &&
            isAdminMode
        "
        @click.prevent="unpublishTray(card.id)"
      >
        {{ $resourceString["account.Trays.Option.Unpublish.Tray"] }}
      </a>
      <div class="dropdown-divider"></div>
      <a
        v-if="
          isAdminMode ||
            selectedTabName === archived ||
            selectedTabName === active
        "
        href=""
        class="dropdown-item font-danger font-16"
        :class="{ disabled: isDisabled }"
        @click.prevent="handleDeleteProject"
      >
        {{ $resourceString["myProject.Project.DeleteProject.Title"] }}
      </a>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["card", "selectedProjectId", "isAdminMode"],
  data() {
    return {
      editTrayId: "",
      archived: this.$resourceString['common.accounts.Label.Archived'],
      active: this.$resourceString['common.accounts.Label.Active'],
      brand: this.$resourceString['common.accounts.Label.Brand'],
    };
  },
  computed: {
    ...mapGetters({
      selectedTabName: "myTray/getselectedTabName",
      getSelectedProjectId: "myTray/getSelectedTrayId"
    }),

    showHideEdit() {
      return this.selectedProjectId?.length <= 1;
    },

    isDisabled() {
      return this.selectedProjectId?.length === 0;
    }
  },
  watch: {
    getSelectedProjectId() {
      this.selectedProjectId = this.getSelectedProjectId;
    }
  },
  methods: {
    ...mapActions({
      deleteVirtualTray: "myTray/deleteVirtualTray",
      archiveVirtualTray: "myTray/archiveVirtualTray",
      updateShareTrayIfFromMyTrayPage: "myTray/updateShareTrayIfFromMyTrayPage",
      virtualTrayEdit: "myTray/virtualTrayEdit",
      publishTrayApi: "myTray/publishTrayApi",
      unpublishTrayApi: "myTray/unpublishTrayApi",
      getUserTrayIdApiDetails: "myTray/getUserTrayIdApiDetails",
      setTabName: "virtualTray/setTabName",
      archiveResourceString: "myTray/archiveResourceString",
      resourceString: "myTray/resourceString",
      modalArchiveMsg: "myTray/modalArchiveMsg",
      updateAllVirtualTray: "myTray/updateAllVirtualTray"
    }),

    async handleArchiveTray() {
      await this.modalArchiveMsg("");
      await this.archiveResourceString(
        this.$resourceString["myProject.Project.Archived.Msg"]
      );
      await this.archiveVirtualTray(this.selectedProjectId);
      await this.updateAllVirtualTray('ProjectFeature');
    },

    async handleDeleteProject() {
      await this.resourceString(
        this.$resourceString["myProject.Project.Deleted.Msg"]
      );
      await this.deleteVirtualTray(this.selectedProjectId);
      await this.updateAllVirtualTray('ProjectFeature');
    },

    showModal(name) {
      this.$modal.show(name + "-modal");
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },

    shareTray(id) {
      this.updateShareTrayIfFromMyTrayPage(id);
      this.showModal("share-tray");
      let data = {
        boardId: id ? id : "",
        isAdmin: this.isAdminMode ? this.isAdminMode : false
      };
      this.getUserTrayIdApiDetails(data);
    },

    async publishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(
        this.$resourceString["common.Published.Msg"]
      );
      await this.publishTrayApi(data);
    },

    async unpublishTray(id) {
      let data = {
        id: id
      };
      await this.resourceString(
        this.$resourceString["common.Unpublished.Msg"]
      );
      await this.unpublishTrayApi(data);
    }
  }
};
</script>
